import { useEffect, useRef } from "react";

export default function useInterval<T extends any[]>(
  callback: (...args: T) => void,
  delay?: number | null,
  immediate: boolean = true,
  ...args: T
) {
  const savedCallback = useRef<(...args: T) => void>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      if (savedCallback.current) {
        savedCallback.current(...args);
      }
    }
    if (delay !== null && delay !== undefined) {
      if (immediate) {
        tick();
      }
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay]);
}
